import { render, staticRenderFns } from "./ChangeLang.vue?vue&type=template&id=738c9659"
import script from "./ChangeLang.vue?vue&type=script&lang=js"
export * from "./ChangeLang.vue?vue&type=script&lang=js"
import style0 from "./ChangeLang.vue?vue&type=style&index=0&id=738c9659&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('738c9659')) {
      api.createRecord('738c9659', component.options)
    } else {
      api.reload('738c9659', component.options)
    }
    module.hot.accept("./ChangeLang.vue?vue&type=template&id=738c9659", function () {
      api.rerender('738c9659', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/ChangeLang.vue"
export default component.exports